var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.666 5.00065V7.11732C15.6743 7.69232 14.9993 8.76732 14.9993 10.0007C14.9993 11.234 15.6743 12.309 16.666 12.884V15.0007H3.33268V12.884C4.33268 12.309 4.99935 11.234 4.99935 10.0007C4.99935 8.76732 4.33268 7.69232 3.33268 7.11732V5.00065H16.666ZM16.666 3.33398H3.33268C2.41602 3.33398 1.66602 4.08398 1.66602 5.00065V8.33398C2.58268 8.33398 3.33268 9.08398 3.33268 10.0007C3.33268 10.9173 2.58268 11.6673 1.66602 11.6673V15.0007C1.66602 15.9173 2.41602 16.6673 3.33268 16.6673H16.666C17.5827 16.6673 18.3327 15.9173 18.3327 15.0007V11.6673C17.416 11.6673 16.666 10.9173 16.666 10.0007C16.666 9.08398 17.416 8.33398 18.3327 8.33398V5.00065C18.3327 4.08398 17.5827 3.33398 16.666 3.33398Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoucher);
export default __webpack_public_path__ + "static/media/icon-voucher.0a07e97d10d07bf1858bb3199d20014a.svg";
export { ForwardRef as ReactComponent };